import React, { useEffect, useState } from "react";
import { api } from "@/lib/apiClient";

const STATS = [
  ["published_articles", "Published Articles"],
  ["draft_articles", "Draft Articles"],
  ["principles", "Principles"],
  ["books", "Books"],
  ["resources", "Resources"],
  ["active_landing_pages", "Active Landing Pages"],
  ["newsletter_signups", "Newsletter Signups"],
  ["leads", "Leads"],
];

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)); }, []);
  if (!stats) return <div className="h-64 bg-slate-100 animate-pulse" />;

  return (
    <div>
      <h1 className="font-serif-display text-2xl font-bold text-[#111827] mb-6">Dashboard</h1>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {STATS.map(([key, label]) => (
          <div key={key} data-testid={`stat-${key}`} className="border border-slate-200 bg-white p-5">
            <div className="text-3xl font-serif-display font-bold text-[#0F2C59]">{stats[key] ?? 0}</div>
            <div className="text-xs text-slate-500 mt-1">{label}</div>
          </div>
        ))}
      </div>

      <h2 className="font-serif-display text-lg font-bold text-[#111827] mt-10 mb-4">Recent Leads</h2>
      <div className="border border-slate-200 bg-white overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b border-slate-200">
            <tr><th className="text-left px-4 py-3">Name</th><th className="text-left px-4 py-3">Email</th><th className="text-left px-4 py-3">Source</th><th className="text-left px-4 py-3">Date</th></tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {(stats.recent_leads || []).length === 0 && <tr><td colSpan={4} className="px-4 py-6 text-center text-slate-400">No leads yet.</td></tr>}
            {(stats.recent_leads || []).map((l) => (
              <tr key={l.id}>
                <td className="px-4 py-3">{l.first_name} {l.last_name}</td>
                <td className="px-4 py-3">{l.email}</td>
                <td className="px-4 py-3">{l.lead_source}</td>
                <td className="px-4 py-3">{l.created_at ? new Date(l.created_at).toLocaleDateString() : ""}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
